import "./HiddenShowreel.module.css";
import Header from "@/reusable_sections/Header";
import Videoshowreel from "./sections/Videoshowreel";
import Footer from "@/reusable_sections/Footer";
export default function HiddenShowreelPage() {
  return <div>
      <Header />
      <Videoshowreel />
      <Footer />
    </div>;
}